import {ContextMenu} from "./contextMenu";

// TODO: Rename to something like ButtonContextMenu as its not only used for the bulk selector button but also
// for additional context menus like the "Add time" button in the recording validations
export class BulkSelectorContextMenu extends ContextMenu<unknown> {
	private readonly dynamicShow: boolean;

	/**
	 * @param dynamicActive if set to true the active status of the context menu is updated on opening
	 * 						note: (only implemented for FancyTreeContextMenu and DataTablesContextMenu)
	 * @param dynamicShow   if set to true the visibility of the context menu is updated on opening
	 */
	public constructor(dynamicActive: boolean = false, dynamicShow: boolean = false) {
		super(dynamicActive);
		this.dynamicShow = dynamicShow;
	}

	/**
	 * Renders the context menu definition.
	 * At this time it will be decided what elements are displayed and what elements are active.
	 */
	public render() {
		return this.renderDropdown("");
	}

	/**
	 * Registers click listeners for the context menu on the specified button.
	 *
	 * @param button The button to register the click listeners on.
	 * @param returnClickedElement If true, the clicked element will be returned instead of the button
	 * @param openOnBody If true the event handler will be registered on the body instead of the button
	 */
	public registerOnButton(button: JQuery, returnClickedElement?: boolean, openOnBody?: boolean) {
		const btnElement = openOnBody ? $("body") : button.closest(".dropdown");
		if (this.dynamicShow) {
			btnElement.on("click", ".dropdown-toggle", (event) => {
				const element = $(event.currentTarget as HTMLElement);
				// remove old dropdown menu
				element.siblings("ul.dropdown-menu").remove();
				// render new dropdown menu with updated show conditions
				element.parent().append(this.render());
			});
		}

		btnElement.on("click", "ul.dropdown-menu > li", (event) => {
			const element = $(event.currentTarget as HTMLElement);
			if (!element.hasClass("disabled")) {
				const action = element.data("action") as string;
				this.triggerAction(action, "", returnClickedElement ? element : button);
			}
		});
	}
}
